export default __webpack_public_path__ + "media/images/close-8e7c9cd445c28782b1c65b33e4a3c14b.svg";